import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-timezone-dropdown',
  templateUrl: './timezone-dropdown.component.html',
  styleUrls: ['./timezone-dropdown.component.css']
})
export class TimezoneDropdownComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
